import request from '@/utils/request'

const api = {
  page: '/pay/wx/merchant/page',
  get: '/pay/wx/merchant/get',
  create: '/pay/wx/merchant/create',
  update: '/pay/wx/merchant/update',
  delete: '/pay/wx/merchant/delete',
  updateStatus: '/pay/wx/merchant/update-status',
  refresh: '/pay/wx/merchant/refresh'
}

export function pageList(params) {
  return request({ url: api.page, method: 'get', params })
}

export function getDetail(params) {
  return request({ url: api.get, method: 'get', params })
}

export function create(data) {
  return request({ url: api.create, method: 'post', data })
}

export function update(data) {
  return request({ url: api.update, method: 'post', data })
}

export function del(params) {
  return request({ url: api.delete, method: 'get', params })
}

export function updateStatus(data) {
  return request({ url: api.updateStatus, method: 'post', data })
}

export function refreshConfig() {
  return request({ url: api.refresh, method: 'get' })
}
